module.exports = __webpack_public_path__ + "img/linkedin.4eafd5a3.svg";